export default __webpack_public_path__ + "static/media/speed.74c7f502.svg";